export default {
    forgot_password_username: 'Usuario',
    forgot_password_password: 'Contraseña',
    forgot_password_confirm_password: 'Confirmar Contraseña',
    forgot_password_required_filed: 'Campo requerido',
    forgot_password_forgot_password: '¿Ha olvidado su contraseña?',
    forgot_password_change_password: 'Cambiar Contraseña',
    forgot_password_sign_in_with_google: 'Acceder con Google',
    forgot_password_confirm_new_password: 'Confirmar Nueva Contraseña',
    page_not_found: 'Oops! Golpeamos un tope de velocidad',
    page_not_found_message: 'Parece que no se encuentra la página que está buscando. Si necesita que lo lleven a otro lugar, pruebe con uno de los botones de la izquierda',
    forgot_password_email: 'Correo Electrónico',
    forgot_password_confirm_password_error: 'Las contraseñas no coinciden',
    forgot_password_error: 'Error',
};